import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPhoneNumber } from '../../common/helpers/phoneHelper';
import { Column } from '../../common/models/table/Column';
import Icon from '../../components/Icon';
import TextOverflowTooltip from '../../components/TextOverflowTooltip';

const notProvided = (
  <span className="secondary-text">
    <FormattedMessage id="notProvided" defaultMessage="not provided" />
  </span>
);

export const columns: Column[] = [{
  Header: () => <FormattedMessage id="email" defaultMessage="Email" />,
  accessor: 'email',
  Cell: ({ cell: { value } }) => (
    <div className="d-flex align-items-center">
      <div className="table-main-icon"><Icon icon="user" /></div>
      {value
        ? <TextOverflowTooltip content={value} width={200}>{value}</TextOverflowTooltip>
        : notProvided}
    </div>
  )
},
{
  Header: () => <FormattedMessage id="firstName" defaultMessage="First name" />,
  accessor: 'firstName',
  Cell: ({ cell: { value } }) => value
},
{
  Header: () => <FormattedMessage id="lastName" defaultMessage="Last name" />,
  accessor: 'lastName',
  Cell: ({ cell: { value } }) => value
},
{
  Header: () => <FormattedMessage id="phoneNumber" defaultMessage="Phone number" />,
  accessor: 'phoneNumber',
  Cell: ({ cell: { value } }) => (value ? formatPhoneNumber(value) : notProvided)
}];
